// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jqWl","right":"styles_right__3o5mh"};